import { getI18n } from '@/plugins/i18n'

import * as dataGridColumn from '@/composables/data-grid-column'

import { useProductService } from '@/services/product.service'
import { useWebSiteStore } from '@/stores/web-site.store'

export const useColumns = (supplierBrand = {}, keepDescription, currency, documentRowType, supersessionId = {}, includesVat = {}, productUnitOfMeasure = {}) => {
  const i18n = getI18n()
  const webSiteStore = useWebSiteStore()
  const { setTotalVatValue, setTotalNoVatValue, setPriceVatValue } = useProductService()

  return [
    {
      type: 'buttons',
      buttons: [{template: 'editButtonsTemplate'}],
      width: '4rem',
      visibleIndex: 0,
      fixed: false
    },
    dataGridColumn.useRowNumberColumn(),
    dataGridColumn.useDocumentRowTypeColumn({
      preserveSupplierBrand: true,
      editCellTemplate: 'documentRowType',
      cellTemplate: 'documentRowTypeCellTemplate',
      productUnitOfMeasure: productUnitOfMeasure,
    }),
    dataGridColumn.useCostColumn({validationRules: []}),
    dataGridColumn.useCostValorizationColumn(),
    dataGridColumn.useSupplierBrandColumn({ supplierBrand, documentRowType }),
    ...dataGridColumn.useProductColumns({ supplierBrand, keepDescription, supersessionId, preserveSupplierBrand: true, productUnitOfMeasure, is_order: true }),
    dataGridColumn.useDescriptionColumn({ validationRules: [{ type: 'required' }] }),
    dataGridColumn.useQuantityColumn(),
    {
      caption: i18n.t('common.deliveredQuantity'),
      dataField: 'delivered_quantity',
      dataType: 'number',
    },
    dataGridColumn.usePriceColumn({
      dataField: 'product_cost',
      caption: i18n.t('common.cost'),
      currency,
      validationRules: [],
      visible: false,
      showInColumnChooser: false
    }),
    dataGridColumn.usePriceColumn({ dataField: 'product_price', caption: i18n.t('common.listing'), currency, validationRules: [], visible: false, showInColumnChooser: false }),
    dataGridColumn.usePriceColumn({ caption: i18n.t('common.unitPriceNoVat'), currency }),
    dataGridColumn.usePriceColumn({
      dataField: 'price_vat',
      caption: i18n.t('common.unitPriceVat'),
      currency,
      setCellValue: (newData, value, currentRowData) => {
        setPriceVatValue(newData, value, currentRowData)
      }
    }),
    dataGridColumn.useDiscountCategoryColumn(),
    ...dataGridColumn.useVatTypeColumns({
      validationRules: [
        {
          type: 'custom',
          message: i18n.t('common.required'),
          reevaluate: true,
          validationCallback: (e) => {
            const type = e.data.document_row_type
            const isRequiredType = type === webSiteStore.documentRowTypesEnum.PRODUCT || type === webSiteStore.documentRowTypesEnum.FREE || type === webSiteStore.documentRowTypesEnum.LABOR || type === webSiteStore.documentRowTypesEnum.EXPENSE || type === webSiteStore.documentRowTypesEnum.SERVICE
            const hasValue = !!e.value
            return hasValue || !isRequiredType
          }
        }
      ]
    }),
    dataGridColumn.useTotalNoVatColumn({ currency, setCellValue: (newData, value, currentRowData) => { setTotalNoVatValue(newData, value, currentRowData) } }),
    dataGridColumn.useTotalVatColumn({ currency, setCellValue: (newData, value, currentRowData) => { setTotalVatValue(newData, value, currentRowData, includesVat.value) } }),
    dataGridColumn.useChargePercentageColumn({ caption: i18n.t('common.chargePercentageAlt') }),
    dataGridColumn.useNotesColumn(),
    dataGridColumn.useDiscountColumn(),
    dataGridColumn.useDiscount2Column(),
    dataGridColumn.useDiscount3Column(),
    dataGridColumn.useUrgencyDiscountColumn(),
    dataGridColumn.useUrgencyDiscount2Column(),
    dataGridColumn.usePaymentTypeColumn(),
    dataGridColumn.usepaidColumn(),
    dataGridColumn.useUnitOfMeasureColumn({
      showClearButton: false,
      productUnitOfMeasure: productUnitOfMeasure,
      validationRules: [
        {
          type: 'custom',
          message: i18n.t('common.required'),
          reevaluate: true,
          validationCallback: (e) => {
            const type = e.data.document_row_type
            const isRequiredType = type === webSiteStore.documentRowTypesEnum.PRODUCT || type === webSiteStore.documentRowTypesEnum.FREE
            const hasValue = !!e.value
            return hasValue || !isRequiredType
          }
        }
      ]
    }),
    dataGridColumn.useUrgencyTypeColumn(),
    dataGridColumn.useRequestedDeliveryDateColumn(),
    dataGridColumn.useDepositColumn({ visible: false, showInColumnChooser: false, validationRules: []}),
    dataGridColumn.useDepositColumn({
      dataField: 'garage',
      caption: i18n.t('common.garage'),
      visible: false,
      showInColumnChooser: false,
      validationRules: []}
    ),
    {
      caption: i18n.t('common.timeEquivalent'),
      dataField: 'timeEquivalent',
      editCellTemplate: 'timeEquivalentEditor',
      editorOptions: { readOnly: true },
      visible: false,
      showInColumnChooser: false,
    }
  ]
}
